import styled from 'styled-components'

import { ModalBodyContainer } from 'components/modal/styled'

export const ModalBody = styled(ModalBodyContainer)`
  max-width: 420px;
  margin: 0 auto;
`
